<template>
    <div>
        <header class="flex items-center px-4 pt-3 sm:px-6 md:pt-4">
            <h1 class="text-xl font-normal font-semibold text-grey-darkest">
                Invite your landlord
            </h1>
        </header>

        <div class="px-4 pt-2 pb-4 border-b sm:px-6">
            <base-alert
                v-if="had_copy_error"
                level="danger"
            >
                <template slot="heading">
                    Whoops!
                </template>

                <template slot="content">
                    There was a problem copying the link to your clipboard. You'll have to manually copy the link.
                </template>
            </base-alert>

            <p class="mb-3">
                Express your interest in Rentora to your landlord.
            </p>

            <p class="mb-6">
                Simply copy the link below and send it to your landlord.
            </p>

            <div
                class="mb-3 overflow-x-scroll whitespace-no-wrap scrollbar-hidden input"
            >
                {{ url }}
            </div>

            <button
                v-clipboard="url"
                v-clipboard:success="onSuccess"
                v-clipboard:error="onError"
                class="w-full btn"
                :class="is_copied ? 'btn-green' : 'btn-blue'"
            >
                {{ is_copied ? 'Link Copied!' : 'Copy Link' }}
            </button>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'
    import scroll from '../../support/scroll'
    import HeadMixin from '../../mixins/head'

    export default {
        mixins: [
            HeadMixin
        ],
        data () {
            return {
                is_copied: false,
                had_copy_error: false,
                url: _.url('/lp/invite-my-landlord?utm_source=rentora&utm_medium=invitation&utm_campaign=landlord-invitation')
            }
        },
        methods: {
            head () {
                return {
                    title: 'Invite your landlord',
                    description: 'Express your interest in using Rentora to your landlord'
                }
            },
            onSuccess () {
                this.$track(
                    'invitations.create',
                    'link-copy',
                    'A landlord invitation link has been copied'
                )

                this.is_copied = true

                setTimeout(() => {
                    this.is_copied = false
                }, 2000)
            },
            onError () {
                scroll.toTop()

                this.had_copy_error = true
            }
        }
    }
</script>
